import { ComponentRegistry } from '@sg-core/resources/assets/js/utils';

export class AlsComponentRegistry extends ComponentRegistry {
  protected getModules(): Record<string, () => Promise<unknown>> {
    return import.meta.glob('/modules/SG/maisons/als/src/View/Components/**/*.ts');
  }
}
